import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService'

export class Privacy extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name
    }));
  }

  render () {
    return (
      <div class="main">
<h4>Политика конфиденциальности</h4>

<p>Planna — ваш персональный планировщик</p>

<p>Последнее обновление: 15.12.2025</p>

<p>Добро пожаловать в Planna! Ваша конфиденциальность крайне важна для нас. Эта Политика объясняет, какую информацию мы собираем, как её используем и защищаем, когда вы пользуетесь нашим сервисом для бронирования, аренды и планирования.</p>

<ol>
<li>Информация, которую мы собираем
<ol>
<li>Информация, которую вы нам предоставляете:
<ul>
<li>Учетные данные: Имя, адрес электронной почты, номер телефона, настройки учетной записи.</li>
<li>Данные профиля: Фотография (если вы добавляете её), предпочтения (например, любимые категории услуг).</li>
<li>Контент бронирований: Подробности ваших бронирований столиков, отелей, аренды (например, даты, время, выбранные опции, особые пожелания), записи к поставщикам услуг.</li>
<li>Информация о партнере: Если вы используете функцию «Найти партнера» для бронирования, требующего двух участников, мы обрабатываем ваши предпочтения для поиска совпадения.</li>
<li>Календарь: С вашего явного согласия мы можем получать доступ к вашему календарю для синхронизации бронирований и создания единого расписания.</li>
<li>Платежная информация: Данные банковской карты обрабатываются и хранятся на стороне сертифицированного платежного партнера (эквайера). Мы не храним полные реквизиты вашей карты на наших серверах.</li>
</ul></li>
<li>Информация, собираемая автоматически:
<ul>
<li>Данные об устройстве: Тип устройства, операционная система, уникальные идентификаторы.</li>
<li>Данные об использовании: История действий в приложении, просмотренные предложения, типы запрашиваемых услуг, частота использования.</li>
<li>Данные календаря поставщиков: Если вы являетесь поставщиком услуг, с вашего согласия мы синхронизируем данные о вашей рабочей загрузке для отображения клиентам.</li>
</ul></li>
</ol></li>

<li>Как мы используем вашу информацию<br/>
Мы используем собранную информацию для:
<ul>
<li>Предоставления и улучшения сервиса: Обработки бронирований, поиска партнеров, показа вашего единого календаря.</li>
<li>Персонализации: Рекомендации услуг, предложения с учетом ваших предпочтений и истории.</li>
<li>Коммуникации: Отправки подтверждений, напоминаний, важных уведомлений (например, о росте загрузки на выбранную дату).</li>
<li>Безопасности: Предотвращения мошенничества и злоупотреблений.</li>
<li>Развития сервиса: Анонимного анализа тенденций для улучшения функционала Planna.</li>
</ul>
</li>

<li>Обмен информацией<br/>
Мы не продаем ваши персональные данные. Мы можем передавать информацию:
<ul>
<li>Поставщикам услуг: Чтобы выполнить ваше бронирование, мы передаем необходимый минимум данных (ваше имя, контакт, время) ресторану, отелю, мастеру или владельцу арендуемого имущества.</li>
<li>Партнеру по функции "Найти партнера": В случае успешного подбора мы обмениваемся между участниками только именами и необходимыми для бронирования данными.</li>
<li>Платежным системам: Для обработки транзакций.</li>
<li>По закону: Если это требуется по закону или для защиты наших прав.</li>
</ul>
</li>

<li>Ваши права<br/>
Вы имеете право:
<ul>
<li>Просматривать, обновлять или удалять данные вашего профиля.</li>
<li>Отказаться от маркетинговых рассылок.</li>
<li>Отозвать согласие на синхронизацию календаря в настройках устройства.</li>
<li>Запросить копию ваших персональных данных.</li>
<li>Удалить аккаунт, обратившись в службу поддержки.</li>
</ul>
</li>

<li>Безопасность<br/>
Мы используем современные методы шифрования (SSL/TLS) для защиты ваших данных при передаче и строгие процедуры для их безопасного хранения.
</li>

<li>Синхронизация календаря<br/>
При включении функции единого календаря:
<ul>
<li>Мы объединяем данные из ваших бронирований в Planna с данными из подключенных внешних календарей (например, Google Calendar, Apple Calendar).</li>
<li>Эта информация используется исключительно для отображения в вашем личном календаре в Planna и не передается третьим лицам в маркетинговых целях.</li>
<li>Вы можете в любой момент отключить синхронизацию в настройках приложения.</li>
</ul>
</li>

<li>Функция "Найти партнера"
<ul>
<li>При использовании этой функции мы сопоставляем пользователей только на основе выбранного бронирования и времени.</li>
<li>Мы никогда не раскрываем ваш полный профиль, контактные данные или историю бронирований потенциальному партнеру без вашего явного согласия в рамках конкретной брони.</li>
<li>После завершения бронирования связь через сервис может быть ограничена.</li>
</ul>
</li>

<li>Изменения в политике<br/>
Мы можем обновлять эту Политику. О существенных изменениях мы уведомим вас через приложение или по электронной почте.
</li>

<li>Связь с нами<br/>
По всем вопросам, касающимся конфиденциальности, обращайтесь:
<ul>
<li>Электронная почта: privacy@planna.ru</li>
<li style={{display: "none"}}>· Юридический адрес: [Указать юридический адрес компании]</li>
</ul>
</li>
</ol>
---
<p>Используя Planna, вы соглашаетесь с условиями этой Политики конфиденциальности.</p>
      </div>
    );
  }
}
